import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Image } from "lucide-react";
import Button from "../../components/common/Button";
import Card from "../../components/common/Card";
import { color } from "../../styles/theme";

const GalleryList = () => {
  const { t } = useTranslation(["gallery", "common"]);
  const navigate = useNavigate();

  return (
    <div>
      <h2 style={s.heading}>{t("galleryList.heading")}</h2>
      <Card style={s.card}>
        <div style={s.iconBadge}><Image size={26} strokeWidth={1.75} color={color.primary500} /></div>
        <p style={s.text}>
          {t("galleryList.description")}
        </p>
        <Button onClick={() => navigate("/events")}>{t("galleryList.goToEvents")}</Button>
      </Card>
    </div>
  );
};

const s = {
  heading: { margin: "0 0 24px", fontSize: 21, fontWeight: 800, color: color.textPrimary, letterSpacing: -0.4 },
  card: { padding: "40px 32px", maxWidth: 440, textAlign: "center" },
  iconBadge: {
    width: 60, height: 60, borderRadius: "50%", background: color.primary50,
    display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px",
  },
  text: { color: color.textSecondary, fontSize: 14, marginBottom: 24, lineHeight: 1.6 },
};

export default GalleryList;
